import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import backendAPI from '../../../utils/backendAPI'

function BillingSuccessPage() {
	const navigate = useNavigate()
	const [error, setError] = useState('')
	const [statusMessage, setStatusMessage] = useState('Confirming payment...')

	useEffect(() => {
		const params = new URLSearchParams(window.location.search)
		const sessionId = params.get('session_id')

		if (!sessionId) {
			setError('Missing checkout session. Please return to Billing and try again.')
			return
		}

		const confirmSession = async () => {
			try {
				const { data } = await backendAPI.get('/api/stripe/checkout-session/', {
					params: { session_id: sessionId },
				})
				const mid = String(data?.merchant_id || data?.metadata?.merchantId || '').trim()
				if (mid) {
					localStorage.setItem('merchant_id', mid)
					localStorage.setItem('business_id', mid)
				}
				localStorage.setItem('billing_success_notice', '1')
				setStatusMessage('Payment successful. Redirecting to billing...')
				setTimeout(() => navigate('/billing?checkout=success', { replace: true }), 1200)
			} catch (err) {
				const msg =
					err.response?.data?.error ||
					err.response?.data?.detail ||
					err.message ||
					'Could not confirm payment session'
				setError(msg)
			}
		}

		confirmSession()
	}, [navigate])

	return (
		<div className="content-page">
			<div className="content">
				<div className="container-fluid" style={{ maxWidth: '700px' }}>
					<br />
					<h1>Payment successful</h1>

					{error && <p className="text-danger">{error}</p>}
					{!error && <p>{statusMessage}</p>}
				</div>
			</div>
		</div>
	)
}

export default BillingSuccessPage
